import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.0778 2.9264C16.8418 2.69154 16.5616 2.50575 16.2534 2.37976C15.9452 2.25376 15.615 2.19006 15.2821 2.19232C14.9491 2.19458 14.6199 2.26276 14.3135 2.39292C14.007 2.52309 13.7293 2.71266 13.4965 2.9507L3.45139 12.9931L2.1875 17.8125L7.00833 16.5493L17.0535 6.50695C17.2917 6.2743 17.4814 5.99674 17.6116 5.69032C17.7419 5.3839 17.8101 5.0547 17.8124 4.72174C17.8146 4.38879 17.7509 4.0587 17.6248 3.75054C17.4987 3.44238 17.3128 3.16227 17.0778 2.9264V2.9264Z",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.7583 4.68811L15.3152 8.24366",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.45142 12.993L5.94447 14.0569L7.01114 16.5458",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgEdit);
export default ForwardRef;
